// extracted by mini-css-extract-plugin
export default {"role-badge":"DEoVh41P","roleBadge":"DEoVh41P","admin":"CSjsExTE"};